import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import EmployeeInformation from "./EmployeeInformation";
import EmployerInformation from "./EmployerInformation";
import JobDescription from "./JobDescription";
import * as utilities from "../../utilities/utils";
import Airsteps from "./Steps";
import validation from "../../utilities/validation";
import ApplicationPending from '../../containers/PendingApplication'
import moment from "moment";
import PropTypes from "prop-types";
import JobDetailModal from "../../containers/Std/JobDetailModal";
import ManagerDetailModal from "../../containers/Std/ManagerDetailModal";
import ConfirmationModalPopup from "../../containers/Std/ConfirmationModalPopup";
import AttachmentDescription from "../../containers/Std/AttachmentDescription";
import {
  EMAILREGEX,
  EIN_ERROR,
  ALPHANUMERICWITHSPACEREGEX,
  COMPANYID,
  ENGLISH,
  FRENCH,
  ALERT_ERROR_MESSAGE,
  NUMBER_FORMAT_REGEX,
  ENG_FRENCH,
  TYPEOFRTWTOCOMPAREWITH,
  PREFERED_LANGUAGE_KEYS,
  POST_CODE_REGEX,
  TWODECIMAL_NUMBERREGEX,
  MODAL_SIZE,
  PREFERREDLANGUAGEDRPDATA,
  PREFERREDLANGUAGEDRPDATA_FRENCH,
} from "../../App.config";
import AccomodationSteps from "./Steps";
import history from "../../utilities/history";
import swal from 'sweetalert';
import DisplayEmployeeName from "../../containers/DisplayEmployeeName";

const AccomodationComponent = (props, context) => {
  const initialState = {
    isSubmitOnce: { value: false },
    selectedFilterValue: {
      value: null,
      isDropdown: true,
      ref: useRef(),
      name: "filterValue",
      isSearchOption: true,
    },
    electedFilterValue: {
      value: null,
      isDropdown: true,
      ref: useRef(),
      name: "filterValue",
      isSearchOption: true,
    },
    searchBy: {
      value: "EIN",
    },
    clientInfo: {
      value: [],
    },
    searchValue: {
      value: "",
    },
    proceedInLang: {
      value: "English",
    },
    employeeBasicInformationId: {
      value: null
    },
    employeeDetailsId: {
      value: null
    },
    employementInformationId: {
      value: null
    },
    absenseDetailsId: {
      value: null
    },
    employeeQuestionConcernId: {
      value: null
    },
    workObservationId: {
      value: null
    },
    firstName: {
      value: "",
      error: "",
      validation: {
        required: true,
        matchPattern: ALPHANUMERICWITHSPACEREGEX,
      },
      ref: useRef(),
      step: 1,
      positionCount: 1,
      label: "STD-Employer-Statement.form.label.text.FirstName",
      isEditable: true
    },
    lastName: {
      value: "",
      error: "",
      validation: {
        required: true,
        matchPattern: ALPHANUMERICWITHSPACEREGEX,
      },
      ref: useRef(),
      step: 1,
      label: "STD-Employer-Statement.form.label.text.LastName",
      positionCount: 2,
      isEditable: true
    },
    location: {
      value: [],
      error: "",
      validation: {
        required: true,
      },
      ref: useRef(),
      step: 2,
      label: "STD-Employer-Statement.form.dropdown.text.Division/Location",
      positionCount: 11,
      isEditable: true
    },
    serviceType: {
      value: ["Accommodation"],
      error: "",

      validation: {
        required: true,
      },
      ref: useRef(),
      step: 1,
      label: "STD-Employer-Statement.form.label.text.serviceType",
      positionCount: 5,
    },
    dateOfBirth: {
      value: "",
      error: "",

      validation: {
        isDate: true,
      },
      ref: useRef(),
      step: 1,
      label:
        "STD-Employer-Statement.form.Employee-Details.calender.text.Birth-Date",
      positionCount: 4,
      isEditable: true
    },
    phone: {
      value: "",
      error: "",
      validation: {
        required: true,
        matchPattern: NUMBER_FORMAT_REGEX,
        type: "Phone Number",
      },
      ref: useRef(),
      step: 2,
      label: "STD-Employer-Statement.form.Employer-Details.label.text.Phone",
      positionCount: 6,
      isEditable: true
    },
    alternativePhone: {
      value: "",
      error: "",
      validation: {
        matchPattern: NUMBER_FORMAT_REGEX,
        type: "Phone Number",
      },
      ref: useRef(),
      step: 2,
      label:
        "STD-Employer-Statement.form.Employer-Details.label.text.Alternate-Phone",
      positionCount: 7,
      isEditable: true
    },
    alternativePhoneType: {
      value: "Work",
    },
    ext: {
      value: "",
    },
    prefferedLanguage: {
      value: [],
      error: "",
      validation: {
        required: true,
      },
      ref: useRef(),
      step: 2,
      label:
        "STD-Employer-Statement.form.Employee-Details.dropdown.text.Employee-Language",
      positionCount: 9,
      isEditable: true
    },
    street: {
      value: "",
      error: "",

      validation: {
        required: true,
      },
      ref: useRef(),
      step: 2,
      label: "STD-Employer-Statement.form.Employee-Details.label.text.Address",
      positionCount: 1,
      isEditable: true
    },
    city: {
      value: "",
      error: "",
      validation: {
        required: true,
      },
      ref: useRef(),
      step: 2,
      label: "STD-Employer-Statement.form.Employee-Details.label.text.City",
      positionCount: 4,
      isEditable: true
    },
    country: {
      value: [],
      error: "",
      validation: {
        required: true,
      },
      ref: useRef(),
      step: 2,
      label: "STD-Employer-Statement.form.Employee-Details.label.text.Country",
      positionCount: 2,
    },
    state: {
      value: [],
      error: "",
      validation: {
        required: true,
      },
      ref: useRef(),
      step: 2,
      label: "STD-Employer-Statement.form.Employee-Details.label.text.Province",
      positionCount: 3,
      isEditable: true
    },
    postalCode: {
      value: "",
      error: "",
      validation: {
        required: true,
        matchPattern: POST_CODE_REGEX,
        type: "Postal Code",
      },
      ref: useRef(),
      label: "STD-Employer-Statement.form.Employee-Details.label.text.Postal",
      positionCount: 5,
      step: 2,
      isEditable: true
    },
    typeOfWork: {
      value: [],
    },
    ein: {
      value: "",
      error: "",
      validation: {
        required: true,
      },
      ref: useRef(),
      step: 1,
      label: "STD-Employer-Statement.form.label.text.Employee-ID/EIN",
      positionCount: 3,
      isEditable: true
    },
    employeeEmail: {
      value: "",
      error: "",
      validation: {
        matchPattern: EMAILREGEX,
        type: "Email",
      },
      ref: useRef(),
      label: "STD-Employer-Statement.form.Employee-Details.label.text.Email",
      positionCount: 8,
      step: 2,
      isEditable: true
    },
    employeeEmailType: {
      value: "Personal",
    },
    decreasedHours: {
      value: "No",
    },
    sTDExpiryDate: {
      value: "",
    },
    alteredDuties: {
      value: "No",
    },
    isAlteredDutiesYes: {
      value: "",
    },
    eligibleLTD: {
      value: "No",
    },
    managerEmailCopy: {
      value: "",
      error: "",
      validation: {
        matchPattern: EMAILREGEX,
        type: "Email",
      },
      ref: useRef(),
      step: 4,
    },
    jobTitle: {
      value: "",
      error: "",
      validation: {
        required: true,
      },
      ref: useRef(),
      label: "STD-Employer-Statement.form.Employee-Details.label.text.Job",
      positionCount: 12,
      step: 2,
      isEditable: true
    },
    dateOfHire: {
      value: "",
      error: "",
      validation: {
        isDate: true,
      },
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employee-Details.label.calender.Date-Of-Hire",
      positionCount: 14,
      step: 2,
      isEditable: true
    },
    contractExpiryDate: {
      value: "",
      error: "",
      validation: {
        // isDate: true,
      },
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employee-Details.label.calender.Contract-Expiry-Date",
      positionCount: 15,
      step: 2,
    },
    department: {
      value: [],
    },
    departmentName: {
      value: "",
      isEditable: true,
    },
    // planLink: {
    //   value: [],
    //   error: "",
    //   validation: {
    //     required: true,
    //   },
    //   ref: useRef(),
    //   label:
    //     "STD-Employer-Statement.form.Employee-Details.label.text.Plan-Type",
    //   positionCount: 13,
    //   step: 2,
    // },
    region: {
      value: [],
      error: "",
      validation: {
        //required: true,
      },
      ref: useRef(),
      label: "STD-Employer-Statement.form.dropdown.text.Region",
      positionCount: 10,
      step: 2,
    },
    enableWorkShift: {
      value: "No",
    },
    workShifts: {
      value: "",
    },
    isEnableSearch: {
      value: false,
    },
    isSearchByLastName: {
      value: false,
    },
    employeeInformationId: {
      value: null
    },
    employerInformationId: {
      value: null
    },
    completeInformationId: {
      value: null
    },
    acmdEmployerInformationId: {
      value: null
    },
    jobDescId: {
      value: null
    },
    acmdWorkingDayId: {
      value: null
    },
    id: {
      value: null
    },
    // dateOfBirth: {
    //   value: "",
    //   error: "",
    //   ref: useRef(),
    //   validation: {
    //     isDate: true,
    //   },
    //   step: 1,
    // },
    // ein: {
    //   value: "",
    //   error: "",
    //   ref: useRef(),
    //   validation: {
    //     required: true,
    //   },
    //   step: 1,
    // },
    fullTime: {
      value: false,
      step: 2,
    },
    parttime: {
      value: false,
    },
    term: {
      value: false,
    },
    contract: {
      value: false,
    },
    other: {
      value: false,
    },
    employmentStatus: {
      value: "fullTime",
    },
    workSchedule: {
      value: props.context.t("ACCOMODATION-Employer-Information.form.label.text.Schedule.Days"),
    },
    otherfield: {
      value: "",
      error: "",
      ref: useRef(),
      validation: {
        // required: true,
      },
      step: 2,
    },
    managerName: {
      value: [],
      error: "",
      // validation: {
      //   required: true,
      // },
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Name",
      positionCount: 16,
      step: 2,
      isEditable: true
    },
    managerNameText: {
      value: "",
      error: "",
      // validation: {
      //   required: true,
      // },
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Name",
      positionCount: 16,
      step: 2,
      isEditable: true
    },
    managerPhone: {
      value: "",
      error: "",
      isEditable: true,
      validation: {
        required: true,
        matchPattern: NUMBER_FORMAT_REGEX,
        type: "Phone Number",
      },
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Phone",
      positionCount: 17,
      step: 2,
    },
    managerEmail: {
      value: "",
      error: "",
      isEditable: true,
      validation: {
        required: true,
        matchPattern: EMAILREGEX,
        type: "Email",
      },
      ref: useRef(),
      label:
        "STD-Employer-Statement.form.Employee-Details.label.text.Manager-Email",
      positionCount: 18,
      step: 2,
    },
    days: {
      value: false,
    },
    evenings: {
      value: false,
    },
    nights: {
      value: false,
    },
    weekWDH: {
      value: [
        {
          shift: "Mon",
          name: "Mon",
          hours: "8.0",
          id: null
        },
        {
          shift: "Tue",
          name: "Tue",
          hours: "8.0",
          id: null
        },
        {
          shift: "Wed",
          name: "Wed",
          hours: "8.0",
          id: null
        },
        {
          shift: "Thus",
          name: "Thus",
          hours: "8.0",
          id: null
        },
        {
          shift: "Fri",
          name: "Fri",
          hours: "8.0",
          id: null

        },
        {
          shift: "Sat",
          name: "Sat",
          hours: "0.0",
          id: null

        },
        {
          shift: "Sun",
          name: "Sun",
          hours: "0.0",
          id: null

        },
      ],
    },
    workInShift: {
      value: "No",
    },
    shiftSpecification: {
      value: "",
    },
    jobDescription: {
      value: "",
      error: "",
      step: 3,
      ref: useRef(),
    },
    jobDescAttach: {
      value: false,
      error: "",
      step: 3,
      ref: useRef(),
    },
    employeeRequest: {
      value: "No",
    },
    ifRequest: {
      value: "",
    },
    solution: {
      value: "No",
    },
    ifCommon: {
      value: "",
    },
    detail1: {
      value: "",
      error: "",
      step: 3,
      ref: useRef(),
    },
    detail2: {
      value: "",
      error: "",
      ref: useRef(),
    },
    detail3: {
      value: "",
      error: "",
      ref: useRef(),
    },
    detail4: {
      value: "",
      error: "",
      ref: useRef(),
    },
    additionalNotesAdd: {
      value: "",
      error: "",
      ref: useRef(),
    },
    declaration: {
      value: false,
      error: "",
      ref: useRef(),
      validation: {
        TermsAndCondition: true,
      },
      step: 3,
    },
    isOtherHasSelected: { value: false },
    workDay: {
      value: "FullTime",
    },
    otherEmploymentStatus: {
      value: "",
    },
    futureCommunication: {
      value: props.managersDetails.languagePreference ? FRENCH : ENGLISH
    },
  };



  const [state, setState] = useState(initialState);
  const [selectedCompanyDrp, setSelectedCompanyDrp] = useState(false);
  const [selectedValueSave, setselectedValueSave] = useState(undefined);
  const [saveAppSave, setSaveAppSave] = useState(undefined);

  const [urlLocation, setUrlLocation] = useState(props.urlLocation);
  const attachmentRef = useRef();
  const editableFieldsName = ['firstName', 'lastName', 'dateOfBirth', 'phone', 'alternativePhone', 'ein', 'employeeEmail',
    'street', 'postalCode', 'city', 'state', 'prefferedLanguage', 'managerName', 'dateOfHire'];

  //Set initial step count after first render
  useEffect(() => {
    props.setMaxStep(3);
    props.setMinStep(1);
    props.setCurrentFormStep(1);
  }, []);

  // clean on unmount
  useEffect(() => {
    return () => {
      onDiscard();
      props.resetAccomodationApplicationUrl();
    };
  }, []);

  useEffect(() => {
    if (props.profileReducer && props.profileReducer.companyServices && !props.profileReducer.companyServices.hasDemographicFileFeature) {
      let fupdatedObj = state["managerNameText"];
      fupdatedObj["error"] = "";
      fupdatedObj["validation"] = {
        required: true
      };
      setState((state) => {
        return {
          ...state,
          ['managerNameText']: fupdatedObj,
        };
      });
    }
    else {
      let updatedObj = state["managerName"];
      updatedObj["validation"] = {
        required: true
      };
      setState((state) => {
        return {
          ...state,
          ['managerName']: updatedObj,
        };
      });
    }
  }, [props.stepCount == 2])

  // Get States by country
  useEffect(() => {
    if (state.country.value && state.country.value.length)
      props.getStates(utilities.extractFirstValueOfArray(state.country.value))

  }, [state.country.value])

  useEffect(() => {
    if (saveAppSave && !Array.isArray(saveAppSave) && saveAppSave.employeeBasicInformation.employeeBasicInformationId > 0) {

      setState((state) => {
        return {
          ...state,
          ['state']: setValueToStateForDrpId("state", saveAppSave.employeeInformation ? saveAppSave.employeeInformation.provinceId : "", props.state, "provinceId", "provinceId"),
        };
      });

    }
    else {
      setState((state) => {
        return {
          ...state,
          ['state']: setValueToStateForDrpId("state", selectedValueSave ? selectedValueSave.provinceId : "", props.state, "provinceId", "provinceId"),
        };
      });

    }

  }, [props.state])

  //Reset form to its initial state after form submit action
  useEffect(() => {
    if (props.isAdded) {
      props.resetIsAdded(false);
      props.setMaxStep(3);
      props.setMinStep(1);
      props.setCurrentFormStep(1);
      onDiscard();
      props.commonReducer && props.commonReducer.successMessage && goToHomeOrNot(props.commonReducer.successMessage);
      props.resetSuccessMessage("");
      // props.getAllPendingApplications(props.managersDetails.managerId);
    }
  }, [props.isAdded]);

  //Open pendingApplication model on page load
  useEffect(() => {
    callModal();
    // props.openSetModalAction(<ApplicationPending />, MODAL_SIZE.MODAL_SM);
    return function cleanup() {
      props.closeRemoveModal();
    };
  }, []);

  const convertLanguageToBool = (langname) => {
    if (langname == "CFR") return true
    return false
  }

  const callModal = () => {
    props.getAllPendingApplications(props.managersDetails.managerId);
  }

  const decidePreferredLngDrp = () => {
    let defaultPreferLang = PREFERREDLANGUAGEDRPDATA;
    if (props.i18nReducerLang === "en-US") {
      defaultPreferLang = PREFERREDLANGUAGEDRPDATA;
    } else {
      defaultPreferLang = PREFERREDLANGUAGEDRPDATA_FRENCH;
    }

    return defaultPreferLang;
  };

  const setDateValueToState = (key, valueToBeSet) => {
    let updatedObj = state[key];
    updatedObj.value = valueToBeSet;
    if (valueToBeSet) {
      updatedObj.isEditable = false;
    }
    else {
      updatedObj.isEditable = true;
    }
    return updatedObj;
  }

  const setValueToState = (key, valueToBeSet) => {
    let updatedObj = state[key];
    updatedObj.value = valueToBeSet ? valueToBeSet.trim() : "";
    if (valueToBeSet) {
      updatedObj.isEditable = false;
    }
    else {
      updatedObj.isEditable = true;
    }
    return updatedObj;
  }

  const setValueToStateForArray = (key, valueToBeSet) => {
    let updatedObj = state[key];
    updatedObj.value = valueToBeSet;
    if (valueToBeSet) {
      updatedObj.isEditable = false;
    }
    else {
      updatedObj.isEditable = true;
    }
    return updatedObj;
  }

  const setValueToStateForDrpById = (key, valueToBeSet, findFromOptions, optionsKey, optionsValue) => {
    let updatedObj = state[key];
    let editableStatus = true;
    if (!valueToBeSet) {
      updatedObj.value = [];
    }
    Array.isArray(findFromOptions) && findFromOptions.map((option) => {
      let optionVal = option[optionsKey];
      if (optionVal.trim() === valueToBeSet) {
        updatedObj.value = [option[optionsKey]]
        updatedObj.isEditable = false;
        editableStatus = false;
      }
    })
    if (editableStatus)
      updatedObj.isEditable = true;
    return updatedObj;
  }

  const setValueToStateForDrpByIdValue = (key, valueToBeSet, findFromOptions, optionsKey, optionsValue) => {
    let updatedObj = state[key];
    let editableStatus = true;
    Array.isArray(findFromOptions) && findFromOptions.map((option) => {
      let optionVal = option[optionsKey] == "ENG" ? false : true;
      if (optionVal === valueToBeSet) {
        updatedObj.value = [option[optionsKey]]
        updatedObj.isEditable = false;
        editableStatus = false;
      }
    })
    if (editableStatus)
      updatedObj.isEditable = true;
    return updatedObj;
  }


  const setValueToStateForDrp = (key, valueToBeSet, findFromOptions, optionsKey, optionsValue) => {
    let updatedObj = state[key];
    let editableStatus = true;
    if (!valueToBeSet) {
      updatedObj.value = [];
    }
    Array.isArray(findFromOptions) && findFromOptions.map((option) => {
      if (option[optionsValue].trim().toLowerCase() === valueToBeSet.toLowerCase()) {
        updatedObj.value = [option[optionsKey]]
        updatedObj.isEditable = false;
        editableStatus = false;
      }
    })
    if (editableStatus)
      updatedObj.isEditable = true;
    return updatedObj;
  }

  const formatPostalCode = (postalCode) => {
    let postalcode = Array.from(postalCode);
    let formatedPostal = "";
    Array.isArray(postalcode) && postalcode.length && postalcode.map((partofpostal, i) => {
      if (i <= 6) {
        if (i == 3) {
          if (partofpostal == " ")
            formatedPostal = formatedPostal + partofpostal;
          else {
            formatedPostal = formatedPostal + " ";
            formatedPostal = formatedPostal + partofpostal;
          }
        }
        else
          formatedPostal = formatedPostal + partofpostal;

      }
    })
    return formatedPostal;
  }

  const setValueToStateForDrpId = (key, valueToBeSet, findFromOptions, optionsKey, optionsValue) => {
    let updatedObj = state[key];
    let editableStatus = true;
    if (!valueToBeSet) {
      updatedObj.value = [];
    }
    Array.isArray(findFromOptions) && findFromOptions.map((option) => {
      if (option[optionsValue] === valueToBeSet) {
        updatedObj.value = [option[optionsKey]]
        updatedObj.isEditable = false;
        editableStatus = false;
      }
    })
    if (editableStatus)
      updatedObj.isEditable = true;
    return updatedObj;
  }

  const onFilterDrpChange = (selectedValue) => {
    // if(!selectedValue){
    //   setState((state) => {
    //     return {
    //       ...initialState
    //     };
    //   });
    // }
    setselectedValueSave(selectedValue);
    selectedValue ? setSelectedCompanyDrp(true) : setSelectedCompanyDrp(false);
    setState((state) => {
      return {
        ...state,
        firstName: setValueToState("firstName", selectedValue ? selectedValue.clientFirstName : ""),
        lastName: setValueToState("lastName", selectedValue ? selectedValue.clientLastName : ""),
        dateOfBirth: setDateValueToState("dateOfBirth", selectedValue && selectedValue.dob ? moment(selectedValue.dob).toDate() : null),
        phone: setValueToState("phone", selectedValue ? normalizeInput(selectedValue.homePhone, "") : ""),
        // alternativePhone: setValueToState("alternativePhone", selectedValue ? selectedValue.workPhone : ""),
        ein: setValueToState("ein", selectedValue ? selectedValue.externalID : ""),
        employeeEmail: setValueToState("employeeEmail", selectedValue ? selectedValue.emailAddress : ""),
        street: setValueToState("street", selectedValue && (selectedValue.address1 || selectedValue.address2) ? selectedValue.address1 + " " + selectedValue.address2 : ""),
        postalCode: setValueToState("postalCode", selectedValue ? formatPostalCode(selectedValue.zip) : ""),
        city: setValueToState("city", selectedValue ? selectedValue.city : ""),
        country: setValueToStateForDrpId("country", selectedValue ? selectedValue.country : "", props.country, "countryId", "countryName"),
        state: setValueToStateForDrpId("state", selectedValue ? selectedValue.provinceId : "", props.state, "provinceId", "provinceId"),
        location: setValueToStateForDrpId("location", selectedValue ? selectedValue.departmentId : "", props.location, "coLocationID_PK", "coLocationID_PK"),
        jobTitle: setValueToState("jobTitle", selectedValue ? selectedValue.jobtitle : ""),
        // setValueToStateForDrp("state", selectedValue ? selectedValue.province : "", props.state, "provinceId", "province"),
        //departmentName: setValueToState("departmentName", selectedValue ? selectedValue.department : ""),
        prefferedLanguage: setValueToStateForDrpById("prefferedLanguage", selectedValue && (selectedValue.language ? selectedValue.language : "CFR"), decidePreferredLngDrp(), "LanguageId", "Language"),
        managerName: setValueToStateForDrp("managerName", selectedValue ? selectedValue.managerName : "", props.supervisorList, "supervisorID_PK", "primaryName"),
        dateOfHire: setDateValueToState("dateOfHire", selectedValue && selectedValue.dateOfHire ? moment(selectedValue.dateOfHire).toDate() : null),
      }
    })
    // editableFieldsName.map((fieldName)=>{
    //   if(state[fieldName].value){
    //     setState((state) => {
    //       return {
    //         ...state,
    //         isEditable: false,
    //       };
    //     });
    //   }
    //   else{
    //     setState((state) => {
    //       return {
    //         ...state,
    //         isEditable: true,
    //       };
    //     });
    //   }
    // })
  }


  const filterApplicationState = useSelector(
    (state) => state.filterReducer
  );

  const onFilterDropDownChange = (selectItems, event) => {
    onDiscard();

    let selectedValue = undefined;

    //Find The value  from array for binding
    Array.isArray(filterApplicationState.filterApplicationValues) &&
      filterApplicationState.filterApplicationValues.map((option, key) => {
        if (selectItems && selectItems.value === option.externalID) {
          selectedValue = option;
        }
      })

    onFilterDrpChange(selectedValue);

    let updatedObj = state.selectedFilterValue;
    updatedObj.value = selectItems;
    setState((state) => {
      return {
        ...state,
        selectedFilterValue: updatedObj,
      };
    });
  }

  // Set value received from DB
  useEffect(() => {
    if (props.contiuedPendingApplicationObj)
      setAcmdvalues();
  }, [props.contiuedPendingApplicationObj])

  const setAcmdvalues = () => {
    let currentState = state;

    const savedApp = props.contiuedPendingApplicationObj;
    setSaveAppSave(savedApp);
    if (savedApp.employeeInformation && savedApp.employeeInformation.employeeInformationId) {
      currentState.employeeInformationId.value = savedApp.employeeInformation.employeeInformationId
      // currentState.city.value = savedApp.employeeInformation.city;
      setValueToState("city", savedApp.employeeInformation ? savedApp.employeeInformation.city : "")
      // currentState.postalCode.value = savedApp.employeeInformation.postalCode;
      setValueToState("postalCode", savedApp.employeeInformation ? savedApp.employeeInformation.postalCode : "")
      // currentState.state.value = savedApp.employeeInformation.provinceId ? [savedApp.employeeInformation.provinceId] : currentState.state.value;
      setValueToStateForDrpId("state", savedApp.employeeInformation ? savedApp.employeeInformation.provinceId : "", props.state, "provinceId", "provinceId")
      currentState.country.value = savedApp.employeeInformation.countryId ? [savedApp.employeeInformation.countryId] : currentState.country.value;
      currentState.alternativePhoneType.value = savedApp.employeeInformation.isPhoneWork ? "Work" : "Mobile";
      currentState.employeeEmailType.value = savedApp.employeeInformation.isEmailWork ? "Work" : "Personal";
      // currentState.phone.value = savedApp.employeeInformation.homeTelephoneNumber;
      setValueToState("phone", savedApp.employeeInformation ? normalizeInput(savedApp.employeeInformation.homeTelephoneNumber, "") : "")
      // currentState.employeeEmail.value = savedApp.employeeInformation.employeeEmail;
      setValueToState("employeeEmail", savedApp.employeeInformation ? savedApp.employeeInformation.employeeEmail : "")
      // currentState.prefferedLanguage.value = savedApp.employeeInformation.employeePreferredLanguageId ? ["CFR"] : ["ENG"];
      setValueToStateForDrpByIdValue("prefferedLanguage", savedApp.employeeInformation ? savedApp.employeeInformation.employeePreferredLanguageId : "", decidePreferredLngDrp(), "LanguageId", "LanguageId")
      currentState.alternativePhone.value = savedApp.employeeInformation.alternateTelephoneNumber;
      // setValueToState("alternativePhone", savedApp.employeeInformation ? savedApp.employeeInformation.alternateTelephoneNumber : "")
      currentState.employeeBasicInformationId.value = savedApp.employeeInformation.EmployeeBasicInformationId_FK;
      // currentState.street.value = savedApp.employeeInformation.address;
      setValueToState("street", savedApp.employeeInformation ? savedApp.employeeInformation.address : "")
    }

    if (savedApp.employeeBasicInformation && savedApp.employeeBasicInformation.employeeBasicInformationId) {
      // onFilterDropDownChange({label: "Jones Gregory - 001649157",value: "001649157"})
      currentState.employeeBasicInformationId.value = savedApp.employeeBasicInformation.employeeBasicInformationId
      // currentState.firstName.value = savedApp.employeeBasicInformation.firstName;
      setValueToState("firstName", savedApp.employeeBasicInformation ? savedApp.employeeBasicInformation.firstName : "")
      currentState.lastName.value = savedApp.employeeBasicInformation.lastName
      setValueToState("lastName", savedApp.employeeBasicInformation ? savedApp.employeeBasicInformation.lastName : "")
      // currentState.ein.value = savedApp.employeeBasicInformation.ein
      setValueToState("ein", savedApp.employeeBasicInformation ? savedApp.employeeBasicInformation.ein : "")
      if (savedApp.employeeBasicInformation && savedApp.employeeBasicInformation.dob) {
        // currentState.dateOfBirth.value = moment(savedApp.employeeBasicInformation.dob).toDate();
        setDateValueToState("dateOfBirth", savedApp.employeeBasicInformation && savedApp.employeeBasicInformation.dob ? moment(savedApp.employeeBasicInformation.dob).toDate() : null)
      }
      currentState.serviceType.value = savedApp.employeeBasicInformation.serviceType ? [savedApp.employeeBasicInformation.serviceType] : currentState.serviceType.value;
    }

    if (savedApp.employerInformation && savedApp.employerInformation.employerInformationId) {
      currentState.employerInformationId.value = savedApp.employerInformation.employerInformationId
      // currentState.region.value = savedApp.employerInformation.regionId ? [savedApp.employerInformation.regionId] : currentState.region.value;
      // currentState.location.value = savedApp.employerInformation.divisionId ? [savedApp.employerInformation.divisionId] : currentState.location.value;
      setValueToStateForDrpId("location", savedApp.employerInformation.divisionId ? savedApp.employerInformation.divisionId : "", props.location, "coLocationID_PK", "coLocationID_PK")
      // currentState.jobTitle.value = savedApp.employerInformation.jobTitle ? savedApp.employerInformation.jobTitle : currentState.jobTitle.value;
      setValueToState("jobTitle", savedApp.employerInformation.jobTitle ? savedApp.employerInformation.jobTitle : currentState.jobTitle.value)
      currentState.department.value = savedApp.employerInformation.departmentId ? [savedApp.employerInformation.departmentId] : currentState.department.value;
      // currentState.departmentName.value = savedApp.employerInformation.departmentName;
      setValueToState("departmentName", savedApp.employerInformation.departmentName ? savedApp.employerInformation.departmentName : currentState.departmentName.value)
      // currentState.planLink.value = [savedApp.employerInformation.planTypeId];
      currentState.workDay.value = savedApp.employerInformation.employementStatus;
      currentState.otherEmploymentStatus.value = savedApp.employerInformation.employeeStatusSpecification;
      currentState.workShifts.value = savedApp.employerInformation.shiftSpecification;
      if (savedApp.employerInformation && savedApp.employerInformation.contractExpiryDate) {
        currentState.contractExpiryDate.value = moment(savedApp.employerInformation.contractExpiryDate).toDate();
      }
      // currentState.managerName.value = savedApp.employerInformation.managerId ? [savedApp.employerInformation.managerId] : currentState.managerName.value;
      if (props.profileReducer && props.profileReducer.companyServices && props.profileReducer.companyServices.hasDemographicFileFeature) {
        setValueToStateForDrpId("managerName", savedApp.employerInformation ? savedApp.employerInformation.managerId : "", props.supervisorList, "supervisorID_PK", "supervisorID_PK")
      }
      else {
        currentState.managerNameText.value = savedApp.employerInformation.managerName ? savedApp.employerInformation.managerName.trim() : currentState.managerNameText.value;
      }

      currentState.managerPhone.value = savedApp.employerInformation.managerPhone ? savedApp.employerInformation.managerPhone : currentState.managerPhone.value;
      currentState.managerEmail.value = savedApp.employerInformation.managerEmail ? savedApp.employerInformation.managerEmail : currentState.managerEmail.value;

      currentState.futureCommunication.value = savedApp.employerInformation.managerLanguagePreference ? FRENCH : ENGLISH;

      if (savedApp.employerInformation && savedApp.employerInformation.doh) {
        // currentState.dateOfHire.value = moment(savedApp.employerInformation.doh).toDate();
        setDateValueToState("dateOfHire", savedApp.employerInformation && savedApp.employerInformation.doh ? moment(savedApp.employerInformation.doh).toDate() : null)
      }
      currentState.enableWorkShift.value = savedApp.employerInformation.doesEmployeeWorkShifts ? "Yes" : "No";
      savedApp.employerInformation && savedApp.employerInformation.workingDays.map((workingDay, index) => {
        currentState.weekWDH.value[index].hours = workingDay.hours;
        currentState.weekWDH.value[index].id = workingDay.id;
      });
    }



    setState((state) => {
      return {
        ...state,
        currentState
      };
    });

    if (savedApp.employeeBasicInformation && savedApp.employeeBasicInformation.employeeBasicInformationId) {
      // onFilterDropDownChange(
      //   {label: "Jones Gregory - 001649157",
      //   value: "001649157"})
      // onFilterDropDownChange(
      //   {label: savedApp.employeeBasicInformation.firstName + " " + savedApp.employeeBasicInformation.lastName + " " + "-" + " " + savedApp.employeeBasicInformation.ein,
      //   value: savedApp.employeeBasicInformation.ein})
    }
    savedApp.employeeBasicInformation && props.setCurrentFormStep(savedApp.employeeBasicInformation.stepsCompleted);


    props.closeRemoveModal();
  }

  // Execuate funtion on search by value change
  useEffect(() => onSearchFilterChange(), [state.searchBy.value]);

  // To Open model if there is any pending applications
  useEffect(() => {
    let length = 0;
    props.allPendingApplications && props.allPendingApplications.map((pendingApplication) => {
      length = pendingApplication.applicationType == "ACMD" ? length + 1 : length;
    })

    if (length > 0) {
      if (urlLocation && urlLocation.state && urlLocation.state.isRedirectFromNotification) {
        props.openSetModalAction(<ApplicationPending applicationType="ACMD" />, MODAL_SIZE.MODAL_MD);
      }
    }

    props.resetACCMDReducer();
    props.setCurrentFormStep(1);
    setState((state) => {
      return {
        ...initialState
      };
    });
  }, [props.allPendingApplications.length])

  const onDiscard = () => {
    props.setAttachment([]);
    setState((state) => {
      return { ...initialState };
    });
    props.resetContiuedPendingApplicationObj();
  };

  const onManagerNameChange = () => {
    if (
      Array.isArray(state.managerName.value) &&
      state.managerName.value.length &&
      state.managerName.value != 0
    ) {
      let { primaryPhone, primaryEmail, primaryName } = props.supervisorList && props.supervisorList.find(
        (manager) =>
          manager.supervisorID_PK.toString() ===
          utilities.extractFirstValueOfArray(state.managerName.value).toString()
      );
      let managerTelephone = utilities.convertIntoObject(
        normalizeInput(primaryPhone, null),
        state.managerPhone
      );

      let managerEmail = utilities.convertIntoObject(
        primaryEmail,
        state.managerEmail
      );

      let fileContactManagerName = utilities.convertIntoObject(
        primaryName,
        state.managerNameText
      );

      if (managerTelephone.value) {
        managerTelephone.isEditable = false;
      }
      else {
        managerTelephone.isEditable = true;
      }

      if (managerEmail.value) {
        managerEmail.isEditable = false;
      }
      else {
        managerEmail.isEditable = true;
      }
      if (fileContactManagerName.value) {
        fileContactManagerName.isEditable = false;
      }
      else {
        fileContactManagerName.isEditable = true;
      }

      setState((state) => {
        return {
          ...state,
          managerPhone: managerTelephone && managerTelephone.value ? managerTelephone : state.managerPhone,
          managerEmail: managerTelephone && managerEmail.value ? managerEmail : state.managerEmail,
          managerNameText: fileContactManagerName && fileContactManagerName.value ? fileContactManagerName : state.managerNameText,
        };
      });
    }
    else {
      let managerTelephone1 = utilities.convertIntoObject(
        "",
        state.managerPhone
      );

      let managerEmail1 = utilities.convertIntoObject(
        "",
        state.managerEmail
      );

      managerTelephone1.isEditable = true;
      managerEmail1.isEditable = true;
      setState((state) => {
        return {
          ...state,
          managerPhone: managerTelephone1,
          managerEmail: managerEmail1,
        };
      });
    }
  };


  // Execute function on set count change
  useEffect(() => onStepCountChange(), [props.stepCount]);

  //Execuate funtion on sidebar language change
  // useEffect(() => setInitialStep(), [props.i18nReducerLang]);

  // Execuate funtion on Manager Name dropdown change
  useEffect(() => onManagerNameChange(), [
    utilities.extractFirstValueOfArray(state.managerName.value),
  ]);

  const setInitialStep = () => {
    props.setCurrentFormStep(1);
  };

  const nextStep = () => {
    if (props.stepCount < props.maxStep) {
      props.setCurrentFormStep(props.stepCount + 1);
    }
  };

  const previousStep = () => {
    if (props.stepCount > props.minStep) {
      props.setCurrentFormStep(props.stepCount - 1);
      utilities.scrollToTop();
    }
  };

  const handleFileUpload = (event) => {
    let { files } = event.target;
    let formData = new FormData();
    if (files[0]) {
      formData.append("file", files[0]);
      formData.append("authToken", utilities.getTokenHeader().authToken);
      props.uploadFiles(formData, props.attachment, props);
    }

    event.target.value = ''
  };

  const download = (filePath) => {
    const link = document.createElement("a");
    link.href = filePath;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const removeFile = (filePath, isDocs, index, allAttachments) =>
    props.openSetModalAction(
      <ConfirmationModalPopup
        {...props}
        onYesClick={() =>
          removeCompanyAttachmentsAction(
            filePath,
            isDocs,
            index,
            allAttachments
          )
        }
      />,
      MODAL_SIZE.MODAL_SM
    );

  const addDescription = (index, attachmentDescription, attachment) => {
    props.openSetModalAction(
      <AttachmentDescription
        {...props}
        index={index}
        attachmentDescription={attachmentDescription}
        attachment={attachment}
      />,
      MODAL_SIZE.MODAL_SM
    )
  };

  const removeCompanyAttachmentsAction = (
    filePath,
    isDocs,
    index,
    allAttachments
  ) => {
    props.removeFiles(filePath, isDocs, index, allAttachments);
    resetFileInput();
    props.closeRemoveModal();
  };

  const resetFileInput = () => {
    if (attachmentRef && attachmentRef.current && attachmentRef.current.value)
      attachmentRef.current.value = "";
  };

  const handleChanges = (event) => {
    let { name, value, checked, type } = event.target;

    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    if (state.isSubmitOnce.value) FormValidation();
    if (
      name === "phone" ||
      name === "alternativePhone" ||
      name === "managerPhone"
    ) {
      setState((previousState) => {
        return {
          ...previousState,
          [name]: utilities.convertIntoObject(
            normalizeInput(updatedObj.value, previousState[name][value]),
            previousState[name]
          ),
        };
      });
    } else {
      setState((state) => {
        return {
          ...state,
          [name]: updatedObj,
        };
      });
    }
  };

  //is search by lastname
  const onSearchFilterChange = () => {
    if (state.searchBy.value === "LastName") {
      setState((state) => {
        return {
          ...initialState,
          searchBy: utilities.convertIntoObject(state.searchBy.value),
          isSearchByLastName: utilities.convertIntoObject(true),
        };
      });
      //props.setIsSearch(false);
    } else {
      setState((state) => {
        return {
          ...initialState,
          clientInfo: utilities.convertIntoObject(
            initialState.clientInfo.value,
            initialState.clientInfo
          ),
          isSearchByLastName: utilities.convertIntoObject(false),
        };
      });
    }
  };

  const onDateChange = (value, name) => {
    let updatedObj = state[name];
    updatedObj.value = value;

    if (state.isSubmitOnce.value) FormValidation();

    setState((state) => {
      return { ...state, [name]: updatedObj };
    });
  };

  const normalizeInput = (value, previousValue) => {
    if (!value) return value;

    //remove any charater without alphnumeric
    const currentValue = value.replace(/[^\d]/g, "");
    const cvLength = currentValue.length;

    if (!previousValue || value.length) {
      if (cvLength < 4) {
        return currentValue;
      } else if (cvLength < 7) {
        return `(${currentValue.slice(0, 3)})-${currentValue.slice(3)}`;
      } else {
        return `(${currentValue.slice(0, 3)})-${currentValue.slice(
          3,
          6
        )}-${currentValue.slice(6, 10)}`;
      }
    }
  };

  const handleWeekShift = (event) => {
    let { name, value } = event.target;
    let updatedObj = state.weekWDH;
    updatedObj.value.forEach((day) => {
      if (day.shift === name) {
        day.hours = value;
      }
    });

    setState((state) => {
      return {
        ...state,
        weekWDH: updatedObj,
      };
    });
  };

  const handlePhoneNumber = (event) => {
    let { name, value, checked, type } = event.target;

    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    if (state.isSubmitOnce.value) FormValidation();

    setState((previousState) => {
      return {
        ...previousState,
        [name]: utilities.convertIntoObject(
          normalizeInput(updatedObj.value, previousState[name][value]),
          previousState[name]
        ),
      };
    });
  };


  const onDropDownChange = (event) => {
    let { name, value } = event;

    let updatedObj = state[name];
    updatedObj.value = value;

    if (state.isSubmitOnce.value) {
      FormValidation();
    }
    setState((state) => {
      return { ...state, [name]: updatedObj };
    });
  };

  const FormValidationForSaveForLater = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        let propertywithnorequired = state[property];
        let validationobj = {}
        // propertywithnorequired.validation;
        Object.keys(propertywithnorequired.validation).forEach(function (key) {
          if (key != "required" && key != "isDate") {
            validationobj[key] = propertywithnorequired.validation[key];
          }
        });
        propertywithnorequired.validation = validationobj;
        let validatedObj = validation(propertywithnorequired, props.context);
        setState((state) => {
          return {
            ...state,
            [property]: validatedObj,
          };
        });
      }
    }
  };
  const FormValidation = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        let validatedObj = validation(state[property], props.context);
        setState((state) => {
          return {
            ...state,
            [property]: validatedObj,
          };
        });
      }
    }
  };

  const isFormValid = (currentStepCount) => {
    let isValid = true;
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        if (
          state[property]?.error.length > 0 &&
          currentStepCount === state[property]?.step
        ) {
          isValid = false;
        }
      }
    }
    return isValid;
  };

  const convertPreferredLanguageBoolean = (lang) => {
    if (lang === ENGLISH || lang === ENG_FRENCH) {
      return false;
    }
    return true;
  };

  /// Validation showing in advance in another form steps
  const onStepCountChange = () => {
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        if (
          state[property]?.error.length > 0 &&
          state[property]?.step === props.stepCount
        ) {
          state[property].error = "";
          setState((previousState) => {
            return {
              ...previousState,
              [property]: state[property],
              isSubmitOnce: utilities.convertIntoObject(false),
            };
          });
        }
      }
    }
  };

  const goToHomeOrNot = (message) => {
    if (props.stepCount == props.maxStep) {
      swal({
        text: message,
        icon: "success",
        buttons: [{
          visible: true,
          text: props.context.t("Form.Submit.Close")
        }, {
          cancel: true,
          visible: true,
          text: props.context.t("Form.Submit.Download.Application")
        }
        ],
        dangerMode: false,
      })
        .then((isDownload) => {
          if (isDownload) {
            if (props.accomodationFormPdfLink) {
              utilities.download(props.accomodationFormPdfLink);
              history.push("/dashboard");
            }
            else {
              history.push("/dashboard");
            }
          }
          else {
            history.push("/dashboard");
          }
        });
    }
    else {
      swal(message)
        .then((value) => {
          // swal(`The returned value is: ${value}`);
          history.push("/dashboard");
        });
    }
  }

  const callAccomodationAPI = (isPassed) => {
    let workShiftData = state.weekWDH && state.weekWDH.value && state.weekWDH.value.map(({ ...day }) => {
      if (!day.hours.toString().length) {
        day.hours = "0.0";
      }
      day.shiftDay = props.context.t(day.shift);
      return {
        id: day.id,
        acmdEmployerInformationId: state.acmdEmployerInformationId.value,
        shiftDay: day.shiftDay,
        hours: day.hours,
      };
    });
    let attachments = [...props.attachment];

    attachments = attachments.map((attachment) => {
      return {
        employeeBasicInfoId_FK: state.employeeBasicInformationId.value,
        fileType: attachment.format,
        fileUploadPath: attachment.path,
        fileLength: attachment.size,
        uploadFileName: attachment.fileName,
        isDoc: attachment.isDoc,
        attachmentDescription: attachment.attachmentDescription,
        attachmentDataId: attachment.attachmentDataId,
      };
    });
    let accomodationData = {
      employeeBasicInformation: {
        employeeBasicInformationId: state.employeeBasicInformationId.value,
        firstName: state.firstName.value,
        lastName: state.lastName.value,
        ein: state.ein.value,
        dob: utilities.toAPIDateFormat(state.dateOfBirth.value),
        serviceType: utilities.extractFirstValueOfArray(
          state.serviceType.value
        ),
        companyId: props.profileReducer.managersDetails.companyId,
        isCompleted: isPassed,
        stepsCompleted: props.stepCount,
        isGeneratePDFinEnglish:
          props.i18nReducerLang === PREFERED_LANGUAGE_KEYS.EnglishUS
            ? true
            : false,
        createdByManagerId: props.managersDetails.managerId,
        isOldDB: false
      },
      employeeInformation: {
        employeeInformationId: state.employeeInformationId.value,
        employeeBasicInfomationId_FK: state.employeeBasicInformationId.value,
        address: state.street.value,
        countryId: utilities.extractFirstValueOfArray(state.country.value),
        provinceId: utilities.extractFirstValueOfArray(state.state.value),
        city: state.city.value,
        postalCode: state.postalCode.value,
        homeTelephoneNumber: state.phone.value,
        alternateTelephoneNumber: state.alternativePhone.value,
        isPhoneWork:
          state.alternativePhoneType.value === "Work" ? true : false,
        employeeEmail: state.employeeEmail.value,
        isEmailWork:
          state.employeeEmailType.value === "Work" ? true : false,
        employeePreferredLanguageId: convertLanguageToBool(
          utilities.extractFirstValueOfArray(state.prefferedLanguage.value)
        ),
      },
      "employerInformation": {
        "employerInformationId": state.employerInformationId.value,
        "employeeBasicInformationId": state.employeeBasicInformationId.value,
        // "regionId": utilities.extractFirstValueOfArray(state.region.value),
        "divisionId": utilities.extractFirstValueOfArray(state.location.value),
        "jobTitle": state.jobTitle.value,
        "departmentId": utilities.extractFirstValueOfArray(state.department.value),
        "departmentName": state.departmentName.value,
        // "planTypeId": utilities.extractFirstValueOfArray(state.planLink.value),
        "doh": utilities.toAPIDateFormat(state.dateOfHire.value),
        "employementStatus": state.workDay.value,
        "employeeStatusSpecification": state.otherEmploymentStatus.value,
        "doesEmployeeWorkShifts": state.enableWorkShift.value == "Yes" ? true : false,
        "shiftSpecification": state.workShifts.value,
        "createdByManager": props.managersDetails.managerId,
        "contractExpiryDate": utilities.toAPIDateFormat(state.contractExpiryDate.value),
        "managerId": utilities.extractFirstValueOfArray(state.managerName.value),
        "fileContactManagerName": state.managerNameText.value,
        "isDemographicFileAvaliable": props.profileReducer && props.profileReducer.companyServices && props.profileReducer.companyServices.hasDemographicFileFeature,
        "managerPhone": state.managerPhone.value,
        "managerEmail": state.managerEmail.value,
        managerLanguagePreference: convertPreferredLanguageBoolean(
          state.futureCommunication.value
        ),
        "workingDays": workShiftData
      },
      jobDescription: {
        jobDescId: state.jobDescId.value,
        employeeInformationId: state.employeeInformationId.value,
        employeeJobDesc: state.jobDescription.value,
        hasEmployeeRequested:
          state.employeeRequest.value === "Yes" ? true : false,
        hasEmployeeRequestedDetail: state.ifRequest.value,
        solutionPlace: state.solution.value === "Yes" ? true : false,
        solutionPlaceDetail: state.ifCommon.value,
        questionFromEmployer1: state.detail1.value,
        questionFromEmployer2: state.detail2.value,
        questionFromEmployer3: state.detail3.value,
        questionFromEmployer4: state.detail4.value,
        additionalNotesAdd: state.additionalNotesAdd.value
      },
      acmdEmployeeAttachments: attachments
    };
    // props.getAllPendingApplications(props.managersDetails.managerId);
    props.addAccomodationStatement(accomodationData);
    // goToHomeOrNot();
  }

  const onSubmit = (isPassed = false, moveToNextPage = true) => {
    if (urlLocation && urlLocation.state && urlLocation.state.isRedirectFromNotification) {
      let tempUrlLocation = urlLocation;
      tempUrlLocation.state.isRedirectFromNotification = false;
      setUrlLocation(tempUrlLocation);
    }
    setState((state) => {
      return {
        ...state,
        isSubmitOnce: utilities.convertIntoObject(true),
      };
    });

    if (props.stepCount !== props.maxStep) {
      document.querySelector("body").scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });

    }
    if (!moveToNextPage && props.stepCount !== props.maxStep) {
      FormValidationForSaveForLater();
      if (isFormValid(props.stepCount)) {
        callAccomodationAPI(isPassed);
      }
    }
    else {
      FormValidation();

      if (isFormValid(props.stepCount)) {

        if (moveToNextPage) {
          nextStep();
        }
        else {
          callAccomodationAPI(isPassed);
        }
      } else {

        ///How to get First error in particular step
        let errorObject = [];

        for (const property in state) {
          if (state[property].step === props.stepCount && state[property].error)
            errorObject.push({
              name: property,
              label: state[property].label,
              error: state[property].error,
            });
        }
        //Setting focus on first error field
        if (state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.focus) {
          state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.focus();
        } else {
          state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.setFocus();
        }
      }
    }



  };

  const onAddJob = () => {
    props.openSetModalAction(
      <JobDetailModal {...props} locationID={state.location.value} />,
      MODAL_SIZE.MODAL_SM // For small modal
    );
  };

  const onAddManager = () => {
    props.openSetModalAction(
      <ManagerDetailModal
        {...props}
        jobID={state.jobTitle.value}
        locationID={state.location.value}
      />,
      MODAL_SIZE.MODAL_SM
    );
  };

  switch (props?.stepCount) {
    case 1:
      return (
        <>
          <div className="Dashboard-Content">
            <DisplayEmployeeName context={props.context} />
            <AccomodationSteps
              currentStep={props.stepCount}
              setCurrentFormStep={props.setCurrentFormStep}
              context={props.context}
            />
            {/* {props.accomodationFormPdfLink ? (
            <div className="alert alertSuccess" role="alert">
              Accommodation form submitted successfully.&nbsp;
              <a onClick={() => utilities.download(props.accomodationFormPdfLink)}>
                Click
              </a>
              here to download Accommodation application.
            </div>
          ) : null} */}
            <div className="alert alertInfo WC-label-text" role="alert">
              {props.context.t(
                "ACCM.TEXT-TITLE"
              )}
            </div>
            <EmployeeInformation
              state={state}
              context={context}
              handleChanges={handleChanges}
              handlePhoneNumber={handlePhoneNumber}
              onDateChange={onDateChange}
              onDropDownChange={onDropDownChange}
              props={props}
              onSubmit={onSubmit}
              onAddJob={onAddJob}
              onFilterDropDownChange={onFilterDropDownChange}
              onFilterDrpChange={onFilterDrpChange}
              selectedValue={selectedCompanyDrp}
            />
          </div>
        </>
      );
    case 2:
      return (
        <>
          <div className="Dashboard-Content">

            <DisplayEmployeeName context={props.context} />
            <AccomodationSteps
              currentStep={props.stepCount}
              setCurrentFormStep={props.setCurrentFormStep}
              context={props.context}
            />
          </div>
          <EmployerInformation
            state={state}
            handleChanges={handleChanges}
            props={props}
            handleWeekShift={handleWeekShift}
            onSubmit={onSubmit}
            previousStep={previousStep}
            onDropDownChange={onDropDownChange}
            onDateChange={onDateChange}
            onAddJob={onAddJob}
            onAddManager={onAddManager}
            selectedValue={selectedCompanyDrp}
          />
        </>
      );
    case 3:
      return (
        <>
          <div className="Dashboard-Content">
            <DisplayEmployeeName context={props.context} />
            <AccomodationSteps
              currentStep={props.stepCount}
              setCurrentFormStep={props.setCurrentFormStep}
              context={props.context}
            />
          </div>
          <JobDescription
            state={state}
            handleChanges={handleChanges}
            handlePhoneNumber={handlePhoneNumber}
            onDateChange={onDateChange}
            props={props}
            onSubmit={onSubmit}
            previousStep={previousStep}
            handleFileUpload={handleFileUpload}
            download={download}
            removeFile={removeFile}
            addDescription={addDescription}
            attachmentRef={attachmentRef}
          />
        </>
      );
    default:
      return null;
  }
};

export default AccomodationComponent;